module.exports = __webpack_public_path__ + "img/remark.9941f533.png";